import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, CheckCircle2 } from 'lucide-react';
export function SolutionVisualization() {
  return <section className="py-24 bg-gradient-to-b from-amber-50 to-[#FFFBEB]" data-id="element-244">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-245">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-246">
          <div className="inline-flex items-center justify-center p-3 bg-amber-100 rounded-full mb-6" data-id="element-247">
            <Sparkles className="w-6 h-6 text-amber-600" data-id="element-248" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-amber-950 mb-6 font-serif" data-id="element-249">
            Ahora imagina esto por un momento...
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16" data-id="element-250">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-amber-100 hover:shadow-xl transition-shadow" data-id="element-251">
            <ul className="space-y-6" data-id="element-252">
              {['Sabes exactamente cuánto puedes gastar sin culpa', 'Llegas a fin de quincena con dinero todavía', 'Abres la app del banco sin miedo', 'Puedes decir “sí” a un antojo sin sentirte irresponsable'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-253">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-254" />
                  <span className="text-lg text-amber-900" data-id="element-255">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="flex flex-col justify-center space-y-6" data-id="element-256">
            <div className="bg-amber-900 text-amber-50 p-8 rounded-2xl shadow-xl transform md:rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-257">
              <p className="text-xl font-medium mb-4" data-id="element-258">
                No te hiciste rica. No ganaste más.
                <br data-id="element-259" />
                <span className="text-amber-400 font-bold text-2xl block mt-2" data-id="element-260">
                  Simplemente tomaste control.
                </span>
              </p>
              <p className="text-amber-200/80" data-id="element-261">
                Eso es lo que hacen las personas que parecen “buenas con el
                dinero”. No hacen magia. Tienen sistema.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-amber-400 rounded-2xl p-8 md:p-12 text-center max-w-3xl mx-auto shadow-2xl shadow-amber-200/50" data-id="element-262">
          <h3 className="text-2xl md:text-3xl font-bold text-amber-950 mb-6" data-id="element-263">
            Y aquí viene la verdad que lo cambia todo:
          </h3>
          <div className="space-y-4 text-xl md:text-2xl font-medium text-amber-800" data-id="element-264">
            <p data-id="element-265">👉 No necesitas ganar más para vivir mejor.</p>
            <p className="text-amber-600 font-bold" data-id="element-266">
              👉 Necesitas organizar mejor lo que ya ganas.
            </p>
          </div>
          <p className="mt-6 text-amber-900/60" data-id="element-267">
            De forma realista. Simple. Adaptada a nuestra realidad.
          </p>
        </motion.div>
      </div>
    </section>;
}